import React from "react";
import "./Career.css";
import jobsData from "../../config/data.json";
import JobCard from "../../components/Career/JobCard";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

const Career = () => {
  const pdfBasePath = "/CareerPdf";

  return (
    <div className="career-page">
      <Navbar showJoinUs={false} withTopSpacing={false} />
      <div className="jobs-career-container">
        <div className="jobs-header">
          <h1 className="jobs-title">Join Our Team</h1>
          <p className="jobs-subtitle">
            Join Terafac to build the future of AI-powered robotics and
            intelligent machine vision.
          </p>
        </div>

        <div className="jobs-grid">
          {jobsData.jobs.map((job) => (
            <JobCard key={job.id} job={job} pdfBasePath={pdfBasePath} />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Career;
